import { useAnalytics } from '@lower-financial/analytics/src/useAnalytics';
import { PropertyOwnership as PropertyOwnershipType } from '@lower-financial/lending-web-api/generated';
import { Testimonial } from '@lightspeed/components/ui/molecules/testimonial';
import { CardToggleLayout } from '@lightspeed/components/shared/card-toggle-screen-layout/card-toggle-layout';
import { TestimonialSidebar } from '@lightspeed/components/shared/sidebars/testimonial-sidebar';

const propertyOwnershipOptions = [
  {
    icon: '🧍‍♂️',
    label: 'Yes, I’m the sole owner.',
    value: PropertyOwnershipType.SoleOwner,
  },
  {
    icon: '👯',
    label: 'Yes, I co-own it with someone else.',
    value: PropertyOwnershipType.CoOwner,
  },
  {
    icon: '🙅',
    label: 'No, I don’t own this property.',
    value: PropertyOwnershipType.NotOwner,
  },
] as const;

const PropertyOwnershipTestimonial = () => (
  <Testimonial
    title={'Best Customer Service and Knowledge'}
    content={'Lower gave me the best customer service with the knowledge needed to help this be the most enjoyable experience I have ever had. They were always available to answer questions and kept me posted of any items immediately. I would recommend in a heartbeat.'}
    author={'Jared P'}
  />
);

export const PropertyOwnership = () => {
  const fireAnalyticsEvent = useAnalytics('property_ownership');

  return (
    <CardToggleLayout
      title={'Are you the owner of the home?'}
      hideBackButton={false}
      subtitle={<>Confirming ownership before we dive in.&nbsp;🏊</>}
      mortgageApplicationField={'propertyOwnership'}
      fireAnalyticsEvent={fireAnalyticsEvent}
      cardOptions={propertyOwnershipOptions}
      desktopSidebar={(
        <TestimonialSidebar
          testimonial={<PropertyOwnershipTestimonial />}
        />
      )}
    />
  );
};
